import { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import SelectInput from "./SelectInput";
import { GenericObjectArrayType, TOption } from "../../types/common";
import { TableFilterProps } from "../../types/table";
import { openModal } from "../../utils/modalUtils";
import { SettingsOutline } from "@raresail/react-ionicons";
import FilterForm from "./FilterForm";
import { beautify, disableFutureDates } from "../../utils/helpers";

const { RangePicker } = DatePicker;

export const TableFilter = (props: TableFilterProps) => {
  const {
    name,
    onChange,
    updateFilterValues,
    filters,
    type,
    selectOptions,
    showHeaders = false,
    header,
  } = props;
  const [options, setOptions] = useState<TOption[]>([]);

  useEffect(() => {
    if (selectOptions) {
      const options = selectOptions || [];
      setOptions(
        options.map((sub: GenericObjectArrayType) => ({
          value: sub.id,
          label: sub.name,
        })),
      );
    }
  }, [selectOptions]);

  function handleFilter() {
    openModal({
      title: "Select filter",
      type: "form",
      formId: "filter-form",
      body: (
        <FilterForm
          filterOptions={{
            startDateKey: `${name}_min_date`,
            endDateKey: `${name}_max_date`,
          }}
        />
      ),
      okText: "Apply",
    })
      .then(({ currValue, stringValue }: any) => {
        updateFilterValues({ ...currValue, stringValue });
      })
      .catch(() => {});
  }

  const TitleText = () => {
    return (
      <div className="capitalize font12 mb-1">
        Filter by {beautify(header) || beautify(name)}
      </div>
    );
  };

  if (type === "select")
    return (
      <div>
        {showHeaders && <TitleText />}
        <SelectInput
          options={options}
          name={name}
          value={
            isNaN(filters?.[name] as any)
              ? filters?.[name]
              : Number(filters?.[name])
          }
          onChange={(value) => onChange(name, value)}
          label={""}
          placeholder={`Search ${header || name}`}
          error={{}}
        />
      </div>
    );

  if (type === "date") {
    const isSingleDate = props.single === true;
    const isRangePicker =
      props.range === true || (!props.single && !props.range);

    if (isSingleDate) {
      // Single date picker
      return (
        <div>
          {showHeaders && <TitleText />}
          <DatePicker
            onChange={(value: any) => {
              onChange(name, value?.format("YYYY-MM-DD") || null);
            }}
            value={filters?.[name] ? dayjs(filters?.[name]) : null}
            style={{ height: 40, width: "100%" }}
            placeholder={`Select ${header || name}`}
            disabledDate={disableFutureDates}
          />
        </div>
      );
    }

    if (isRangePicker) {
      // Date range picker
      const startDateKey =
        props.dateRangeNames?.startDateKey || "created_at_min_date";
      const endDateKey =
        props.dateRangeNames?.endDateKey || "created_at_max_date";

      return (
        <div>
          {showHeaders && <TitleText />}
          <RangePicker
            disabledDate={disableFutureDates}
            onChange={(value: any) => {
              updateFilterValues({
                [startDateKey]: value?.[0]?.format("YYYY-MM-DD") || null,
                [endDateKey]: value?.[1]?.format("YYYY-MM-DD") || null,
              });
            }}
            value={[
              filters?.[startDateKey] ? dayjs(filters?.[startDateKey]) : null,
              filters?.[endDateKey] ? dayjs(filters?.[endDateKey]) : null,
            ]}
            style={{ height: 40 }}
          />
        </div>
      );
    }
  }
  if (type === "date_select") {
    return (
      <div>
        {showHeaders && <TitleText />}
        <Button onClick={handleFilter}>
          <SettingsOutline />
          Filter
        </Button>
      </div>
    );
  }
  return (
    <div>
      {showHeaders && <TitleText />}
      <input
        type="text"
        className="form-control"
        name={name}
        onBlur={(event) => onChange(name, event.target.value)}
        style={{ fontSize: 13 }}
        placeholder={showHeaders ? `Search ${header || name}` : ""}
      />
    </div>
  );
};
